export default [
	{
		id: "pending",
		name: "resources.user-wtrs.status.pending",
	},
	{
		id: "complete",
		name: "resources.user-wtrs.status.complete",
	},
	{
		id: "deleted",
		name: "resources.user-wtrs.status.deleted",
	},
];
